module.exports = __webpack_public_path__ + "static/media/international-health-partners.967238a0.png";